import styled from 'styled-components';

export const Container = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  background: transparent;
  color: ${({ theme }) => theme.colors.black};
  width: 100%;
  cursor: pointer;
  transition: all 200ms ease-in-out;

  .checkbox {
    width: 21px;
    height: 21px;
    min-width: 21px;
    min-height: 21px;
    border: 1px solid ${({ theme }) => theme.colors.black};
  }

  svg {
    cursor: pointer;
    position: absolute;
    right: 3.2rem;
  }

  input {
    appearance: none;
  }

  span {
    border-radius: 4px;
    height: 2.1rem;
    width: 2.1rem;
    background: #fff;
    border: 0.1rem solid ${({ theme }) => theme.colors.black};
    display: block;
    position: absolute;
    left: 0;
    top: 2px;
  }

  span:after {
    content: '';
    height: 1.8rem;
    width: 1.8rem;
    background: ${({ theme }) => theme.colors.yellow};
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(0);
    border-radius: 4px;
    transition: 300ms ease-in-out 0s;
  }

  input[type='checkbox']:checked ~ span:after {
    transform: translate(-50%, -50%) scale(1);
  }
`;

export const Label = styled.label`
  font-size: 1.4rem;
  margin-left: 40px;
  color: ${({ theme }) => theme.colors.black};
  opacity: 0.65;
  user-select: none;
`;
